import { combineReducers } from 'redux';
import execute, * as fromExecute from './execute';
import compose, * as fromCompose from './compose';

export default combineReducers({
  execute,
  compose,
});

export const getExecutionEvents = (state) => fromExecute.getEvents(state.execute);

export const getRevenue = (state) => fromExecute.getRevenue(state.execute);

export const getPayers = (state) => fromExecute.getPayers(state.execute);

export const getUniqueUsers = (state) => fromExecute.getUniqueUsers(state.execute);

export const getExecuteTime = (state) => fromExecute.getExecuteTime(state.execute);

export const getRevenueCurrencySymbol = (state) =>
  fromExecute.getRevenueCurrencySymbol(state.execute);

export const isExecuting = (state) => fromExecute.isExecuting(state.execute);

export const getExecuteId = (state) => fromExecute.getExecuteId(state.execute);

export const getOptions = (state) => fromExecute.getOptions(state.execute);

export const getExecutedQueryType = (state) => fromExecute.getExecutedQueryType(state.execute);

export const getGroupColumn = (state) => fromCompose.getGroupColumn(state.compose);

export const getAmountField = (state) => fromCompose.getAmountField(state.compose);

export const getAmountFields = (state) => fromCompose.getAmountFields(state.compose);

export const getSplitColumn = (state) => fromCompose.getSplitColumn(state.compose);

export const getQueryType = (state) => fromCompose.getQueryType(state.compose);

export const getPaymentFilter = (state) => fromCompose.getPaymentFilter(state.compose);
